/* Copyright 2013 - 2024 Waiterio LLC */
let window_ = {}

if (typeof window !== 'undefined') {
  window_ = window
}

export default window_
